import React, {
    useState,
    forwardRef,
    useImperativeHandle,
    useEffect,
    ForwardedRef,
} from 'react';
import { Card, Checkbox, Input } from '../../../../shared/custom-ui';

interface IrFormProps {
    defaultValues?: Record<string, any>;
}

const IrForm = forwardRef((props: IrFormProps, ref: ForwardedRef<any>) => {
    const { defaultValues = {} } = props;
    const [irObj, setIrObj] = useState<Record<string, any>>({});
    const [isPrefilled, setIsPrefilled] = useState(false);

    useEffect(() => {
        if (!isPrefilled && Object.keys(defaultValues).length > 0) {
            setIrObj(prev => ({ ...prev, ...defaultValues }));
            setIsPrefilled(true);
        }
    }, [defaultValues, isPrefilled]);

    useImperativeHandle(ref, () => ({
        getData: () => irObj,
    }));

    const handleCheckboxChange = (key: string) => {
        setIrObj(prev => {
            if (prev[key]) {
                const { [key]: _, ...rest } = prev;
                return rest;
            }
            return { ...prev, [key]: true };
        });
    };

    const handleInputChange = (key: string, value: string | null) => {
        setIrObj(prev => {
            if (value) {
                return { ...prev, [key]: value };
            } else {
                const { [key]: _, ...rest } = prev;
                return rest;
            }
        });
    };

    return (
        <Card title="Interventional Radiology (IR)" padding="small">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-4">
                <Checkbox
                    label="Thoracentesis"
                    checked={irObj.thoracentesis || false}
                    onChange={() => handleCheckboxChange("thoracentesis")}
                />
                <Checkbox
                    label="Paracentesis"
                    checked={irObj.paracentesis || false}
                    onChange={() => handleCheckboxChange("paracentesis")}
                />
                <Checkbox
                    label="Port Placement/Removal"
                    checked={irObj.port_placement_removal || false}
                    onChange={() => handleCheckboxChange("port_placement_removal")}
                />
                <Checkbox
                    label="Port check"
                    checked={irObj.port_check || false}
                    onChange={() => handleCheckboxChange("port_check")}
                />
                <Checkbox
                    label="Thyroid biopsy/Fine needle aspiration"
                    checked={irObj.thyroid_biopsy || false}
                    onChange={() => handleCheckboxChange("thyroid_biopsy")}
                />
                <Checkbox
                    label="Lymph node biopsy"
                    checked={irObj.lymph_node_biopsy || false}
                    onChange={() => handleCheckboxChange("lymph_node_biopsy")}
                />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-3 p-4">
                <Checkbox
                    label="Other/Consult"
                    checked={irObj.other_consult || false}
                    onChange={() => handleCheckboxChange("other_consult")}
                />
                <Input
                    label="Specify"
                    value={irObj.specify || ""}
                    onChange={(e) => handleInputChange("specify", e.target.value)}
                />
            </div>
        </Card>
    );
});

export default IrForm;
